import { NgModule } from '@angular/core';
import { ElementTimelineComponent } from './element-timeline/element-timeline.component';
import { SharedProviderModule } from '../shared/shared.module';
import { NotificationService } from '../components/notification/notification.service';
import { OrderByModule } from '../components/order-by/order-by.module';
import { AlarmService } from '../alarm/alarm.service';
import { SidebarService } from '../shared/sidebar/sidebar.service';
import { QmPipesModule } from '../components/qm-pipes/qm-pipes.module';
import { ElementDetailsComponent } from './element-details/element-details.component';
import { NgbNavModule, NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MeasurementsModule } from '../measurements/measurements.module';
import { ElementUtilsModule } from '../element-utils/element-utils.module';
import { FiltersModule } from '../sidebar/filters/filters.module';
import { ElementHoverComponent } from './element-hover/element-hover.component';
import { ElementTextComponent } from './element-text/element-text.component';

@NgModule({
  imports: [
    ElementUtilsModule,
    MeasurementsModule,
    SharedProviderModule,
    OrderByModule,
    QmPipesModule,
    NgbNavModule,
    FiltersModule,
    NgbPaginationModule,
    NgbTooltipModule
  ],
  declarations: [ElementTimelineComponent, ElementDetailsComponent, ElementHoverComponent, ElementTextComponent],
  exports: [ElementTimelineComponent, ElementDetailsComponent, ElementHoverComponent, ElementTextComponent],
  providers: [NotificationService, AlarmService, SidebarService]
})
export class ElementDetailsModule {
}
